import { useParams } from 'quartz-routing/react-router';
import { useSavePlaylist, useSetHiddenForOwner, useUnsavePlaylist } from './myPlaylistsQueries';
import { usePlaylist } from '../savedItems/savedItemsQueries';
export const useMyPlaylistsParams = () => {
  const {
    page,
    tab
  } = useParams();
  return {
    page,
    tab: tab || 'all'
  };
};
export const usePlaylistSaveStatus = playlistId => {
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId);
  const isSaved = playlist && playlist.savedByUser;
  const [savePlaylist] = useSavePlaylist(playlistId);
  const [unsavePlaylist] = useUnsavePlaylist(playlistId);
  const togglePlaylistSaveStatus = () => {
    if (isSaved) return unsavePlaylist();else return savePlaylist();
  };
  return {
    isSaved,
    isLoading: playlistLoading,
    togglePlaylistSaveStatus
  };
};
export const usePlaylistArchivedStatus = playlistId => {
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId);
  const isArchived = playlist && playlist.hiddenForOwner;
  const [toggleHiddenForOwner] = useSetHiddenForOwner(playlistId, !!playlist && !playlist.hiddenForOwner);
  return {
    isArchived,
    isLoading: playlistLoading,
    togglePlaylistArchivedStatus: toggleHiddenForOwner
  };
};